// Shared form primitives used by SectionEditor (moved out of SectionView during the
// sections/ refactor — SectionEditor referenced them without an import which crashed the editor).
import { arr } from "./constants";

export const F = ({ label, value, onChange, textarea, placeholder }) => (
  <label className="block">
    <span className="vp-label mb-1.5 block" style={{ fontSize: "0.65rem" }}>{label}</span>
    {textarea
      ? <textarea rows={3} className="vp-input text-sm" value={value || ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
      : <input className="vp-input text-sm" value={value || ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />}
  </label>
);

export const ListEditor = ({ label, items, fields, onChange, minRow = 0 }) => {
  const rows = arr(items);
  const add = () => onChange([...rows, Object.fromEntries(fields.map((f) => [f.key, ""]))]);
  const remove = (i) => onChange(rows.filter((_, x) => x !== i));
  const patch = (i, k, v) => onChange(rows.map((r, x) => (x === i ? { ...r, [k]: v } : r)));
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <div className="vp-label" style={{ fontSize: "0.65rem" }}>{label}</div>
        <button type="button" onClick={add} className="text-xs text-[#0B5CFF] hover:underline">+ Add row</button>
      </div>
      <div className="space-y-3">
        {rows.map((r, i) => (
          <div key={i} className="vp-card p-3 space-y-2">
            {fields.map((f) => <F key={f.key} label={f.label} textarea={f.textarea} value={r[f.key]} onChange={(v) => patch(i, f.key, v)} />)}
            {rows.length > minRow && (
              <button type="button" onClick={() => remove(i)} className="text-xs text-[#B00020] hover:underline">Remove</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
